<mat-error
  *ngIf="control.errors"
  class="position-absolute"
  [class.dark-theme-bg]="themeMode === 'dark'"
  [class.light-theme-bg]="themeMode === 'light'"
>
  <ng-container *ngIf="control.errors['required']">{{ label }} is required.</ng-container>
  <ng-container *ngIf="control.errors['pattern']"
  >The entered value does not match the template: {{ label }}</ng-container
  >
  <ng-container *ngIf="control.errors['invalidGoogleMapsLink']">Invalid google maps link</ng-container>
  <ng-container *ngIf="control.errors['email'] && control.value?.length">Invalid email.</ng-container>
  <ng-container *ngIf="control.errors['url'] && control.value?.length">Invalid URL.</ng-container>
  <ng-container *ngIf="control.errors['invalidTimeRange']">Invalid time range.</ng-container>
  <ng-container *ngIf="control.errors['minlength']">
    Please enter at least {{ control.errors['minlength'].requiredLength }} characters.
  </ng-container>
  <ng-container *ngIf="control.errors['dateMinimum']">
    Date must be no earlier than {{ control.errors['dateMinimum'].minimum }}.
  </ng-container>
  <ng-container *ngIf="control.errors['dateMaximum']">
    Date must be no later than {{ control.errors['dateMaximum'].maximum }}.
  </ng-container>
  <ng-container *ngIf="control.errors['mask']"> Does not match mask <br /> </ng-container>
  <ng-container *ngIf="control.errors['pattern']"> Does not match pattern <br /> </ng-container>
  <ng-container *ngIf="control.errors | customValidationError as customError">
    {{ customError.message }}
  </ng-container>

  <ng-container *ngIf="control.errors['passwordWantSpecialCharts']">
    Password must include symbols !@#%...
  </ng-container>
  <ng-container *ngIf="control.errors['needSpecialCharts']"> Password must include symbols !@#%... </ng-container>
  <ng-container *ngIf="control.errors['onlyDigLeterSpace']">
    Field must include only letter, number, space or _</ng-container
  >
  <ng-container *ngIf="control.errors['vinTemplateerror']">
    VIN code field must include only letter and number</ng-container
  >
  <ng-container *ngIf="control.errors['mcdotNumberError']">
    MC/DOT must start with 1-9 and have 1-11 digits.</ng-container
  >
  <ng-container *ngIf="control.errors['needLowerCaseCharts']">
    Password must include at least 1 lowercase.
  </ng-container>
  <ng-container *ngIf="control.errors['passwordTooShort'] && !control.errors['required']">
    Min 8 characters.
  </ng-container>
  <ng-container *ngIf="control.errors['needUpperCaseCharts'] && !control.errors['passwordTooShort'] && !control.errors['required']">
    Min 1 uppercase letter.
  </ng-container>
  <ng-container *ngIf="control.errors['needDigitCharts'] && !control.errors['needUpperCaseCharts'] && !control.errors['passwordTooShort'] && !control.errors['required']">
    Min 1 digit.
  </ng-container>
  <ng-container *ngIf="control.errors['mustMatch']">Passwords must match.</ng-container>
  <ng-container *ngIf="control.errors['isNotValidAsync']">Passwords is not valid.</ng-container>
  <ng-container *ngIf="control.errors['mustNotMatch']">Please enter a new password.</ng-container>
  <ng-container *ngIf="control.errors['date30DaysRange']">Period must be less than 30 days.</ng-container>
  <ng-container *ngIf="control.errors['sameAsDriver']">Drivers must be different.</ng-container>
</mat-error>
